exports.default = {
  locale: {
    'zh-cn': '簡躰',
    'zh-tw': '繁躰',
    'en-us': '英文'
  },
  router: {
    'home': '首頁',
    'image-generation': 'AI 圖片',
    'video-generation': 'AI 影片',
    'web-generation': 'AI 網頁',
    'user-center': '用戶中心',
    'user-set': '用戶設置',
    'team-invitation': '成員邀請',
    'team-manage': '團隊管理',
    'team-set': '團隊設置',
    'team-member-department': '成員部門',
    'team-member-approve': '成員審批',
    'team-role-management': '角色管理',
    'team-limit-management': '限額管理',
    'team-consumption-records': '消費記錄',
    'chat-creation': '對話',
    'agent-creation': '智能體管理',
    'agent-setting': '智能體設置',
    'agent-link': '連接集成',
    'agent-data-analysis': '數據分析',
    'agent-user-feedback': '用戶反饋',
    'agent-member-setting': '成員設置',
    'chat-apps': '智能體中心',
    'chat-export': '導出會話記錄',
    'chat-img-mj': 'MidJourney 繪畫中心',
    'chat-img-sd': 'Stable Diffusion 繪畫中心',
    'chat-images-wall': '作品展示',
    'dashboard': '發現',
    'invitation': '推廣計劃',
    'knowledge': '項目',
    'knowledge-manage': '項目管理',
    'asset': '資產'
  },
  message: {
  },
  layout: {
  },
  common: {
    please_select: '請選擇',
    please_enter: '請輸入',
    operation: '操作',
    delete: '刪除',
    send: '發送',
    tips: '提示',
    confirm: '確定',
    cancel: '取消',
    submit: '提交',
    other: '其他',
    success: '成功',
    fail: '失敗',
    user: '用護',
    share: '分享',
    sign_in: '登錄',
    copy: '復製'
  }
}
